import React from 'react'
import { createIcon } from '@chakra-ui/react'

export const EsFlag = createIcon({
  displayName: 'EsFlag',
  viewBox: '0 0 750 500',
  path: [
    <svg height="500" key="EsFlag" width="750">
      <rect fill="#c60b1e" height="500" width="750" />
      <rect fill="#ffc400" height="250" width="750" y="125" />
    </svg>,
  ],
})
